import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BaseUrl } from '../../Page/common/BaseUrl';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
};

export const fetchMyModules = createAsyncThunk(
  'employeeModules/fetchMyModules',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${BaseUrl}/emp/my-modules`,
        getAuthHeaders()
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const employeeModulesSlice = createSlice({
  name: 'employeeModules',
  initialState: {
    allowedModules: [],
    loading: false,
    loaded: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyModules.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyModules.fulfilled, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.allowedModules = action.payload.modules || [];
      })
      .addCase(fetchMyModules.rejected, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.error = action.payload;
        state.allowedModules = [];
      });
  },
});

export default employeeModulesSlice.reducer;
